
export const getpurchaseGroup1 = [
  { name: "RM01 – Raw Materials" },
  { name: "PM01 – Packaging Materials" },
  { name: "SV01 – Services" },
  { name: "SP01 – Spare Parts" },
  { name: "AM01 – Asset Procurement" },
]

export const getCostCenterOptions = [
  { name: "Production - Plant 1", description: "Production - Plant 1", code: "CC01" },
  { name: "Production - Plant 2", description: "Production - Plant 2", code: "CC02" },
  { name: "Packaging", description: "Packaging", code: "CC03" },
  { name: "Machine Shop", description: "Machine Shop", code: "CC04" },
  { name: "Production", description: "Production", code: "CC05" },
  { name: "Engineering Design", description: "Engineering Design", code: "CC06" },
  { name: "Preventive Maintenance", description: "Preventive Maintenance", code: "CC07" },
  { name: "Breakdown Maintenance", description: "Breakdown Maintenance", code: "CC08" },
  { name: "Plant Engineering", description: "Plant Engineering", code: "CC09" },
  { name: "Warehouse", description: "Warehouse", code: "CC10" },
  { name: "Transportation", description: "Transportation", code: "CC11" },
  { name: "Dispatch", description: "Dispatch", code: "CC12" },
  { name: "Corporate Procurement", description: "Corporate Procurement", code: "CC13" },
  { name: "Vendor Management", description: "Vendor Management", code: "CC14" },
  { name: "Strategic Sourcing", description: "Strategic Sourcing", code: "CC15" },
  { name: "HR", description: "HR", code: "CC16" },
  { name: "All Departments", description: "All Departments", code: "CC17" },
  { name: "Human Resources", description: "Human Resources", code: "CC18" },
  { name: "IT Infrastructure", description: "IT Infrastructure", code: "CC19" },
  { name: "Application Support", description: "Application Support", code: "CC20" },
  { name: "Quality Control", description: "Quality Control", code: "CC21" },
  { name: "Quality Assurance", description: "Quality Assurance", code: "CC22" },
  { name: "R&D", description: "R&D", code: "CC23" },
  { name: "Product Development", description: "Product Development", code: "CC24" },
  { name: "Administration", description: "Administration", code: "CC25" },
  { name: "Utilities", description: "Utilities", code: "CC26" },
  { name: "Security", description: "Security", code: "CC27" },
  { name: "Housekeeping", description: "Housekeeping", code: "CC28" },
  { name: "Environment, Health & Safety", description: "Environment, Health & Safety", code: "CC29" },
  { name: "All Cost Centers", description: "All Cost Centers", code: "CC30" },
  { name: "Finance", description: "Finance", code: "CC31" },
  { name: "Corporate", description: "Corporate", code: "CC32" },
  { name: "IT", description: "IT", code: "CC33" }
];

export const getGLAccountOptions = [
  { name: "510001-Raw Material Consumption", description: "Raw Material Consumption", code: "510001" },
  { name: "510002-Packing Material Expense", description: "Packing Material Expense", code: "510002" },
  { name: "510003-Consumables Expense", description: "Consumables Expense", code: "510003" },
  { name: "510004-Engineering Material Expense", description: "Engineering Material Expense", code: "510004" },
  { name: "520001-Maintenance Expense", description: "Maintenance Expense", code: "520001" },
  { name: "520002-Plant Repairs & Maintenance", description: "Plant Repairs & Maintenance", code: "520002" },
  { name: "530001-Warehouse Operating Expense", description: "Warehouse Operating Expense", code: "530001" },
  { name: "530002-Freight & Transportation Expense", description: "Freight & Transportation Expense", code: "530002" },
  { name: "530003-Dispatch Expense", description: "Dispatch Expense", code: "530003" },
  { name: "540001-Procurement Expense", description: "Procurement Expense", code: "540001" },
  { name: "540002-Vendor Development Expense", description: "Vendor Development Expense", code: "540002" },
  { name: "540003-Tender & RFQ Expense", description: "Tender & RFQ Expense", code: "540003" },
  { name: "550001-Salaries & Wages", description: "Salaries & Wages", code: "550001" },
  { name: "550002-Staff Welfare Expense", description: "Staff Welfare Expense", code: "550002" },
  { name: "560001-IT Infrastructure Expense", description: "IT Infrastructure Expense", code: "560001" },
  { name: "560002-Software License Expense", description: "Software License Expense", code: "560002" },
  { name: "560003-Cloud Hosting Expense", description: "Cloud Hosting Expense", code: "560003" },
  { name: "570001-Quality Inspection Expense", description: "Quality Inspection Expense", code: "570001" },
  { name: "570002-Testing & Calibration Expense", description: "Testing & Calibration Expense", code: "570002" },
  { name: "580001-Research & Development Expense", description: "Research & Development Expense", code: "580001" },
  { name: "580002-Product Development Expense", description: "Product Development Expense", code: "580002" },
  { name: "590001-Office Administration Expense", description: "Office Administration Expense", code: "590001" },
  { name: "590002-Utilities Expense", description: "Utilities Expense", code: "590002" },
  { name: "590003-Security Expense", description: "Security Expense", code: "590003" },
  { name: "590004-Housekeeping Expense", description: "Housekeeping Expense", code: "590004" },
  { name: "590005-EHS Expense", description: "EHS Expense", code: "590005" },
  { name: "600001-Travel & Conveyance", description: "Travel & Conveyance", code: "600001" },
  { name: "600002-Training Expense", description: "Training Expense", code: "600002" },
  { name: "600003-Professional Fees", description: "Professional Fees", code: "600003" },
  { name: "600004-Communication Expense", description: "Communication Expense", code: "600004" }
];

export const getPriorityOptions=[
  {name:"Low", description:"Low Priority", code:"LOW"},
  {name:"Medium", description:"Medium Priority", code:"MEDIUM"},
  {name:"High", description:"High Priority", code:"HIGH"},
  {name:"Critical", description:"Critical Priority", code:"CRITICAL"}
];

export const getBusinessUnitOptions=[
  {name:"BU1 - Manufacturing", description:"Manufacturing", code:"BU1"},
  {name:"BU2 - Sales", description:"Sales", code:"BU2"},
  {name:"BU3 - Operations", description:"Operations", code:"BU3"},
  {name:"BU4 - Services", description:"Services", code:"BU4"},
];

export const getDeliveryAddressOptions = [
  { 
    name: "DA01 - Main Warehouse, MG Road", 
    description: "No. 45, MG Road, Shivaji Nagar, Bangalore, Karnataka 560001", 
    code: "DA01" 
  },
  { 
    name: "DA02 - Secondary Hub, HSR Layout", 
    description: "Sector 2, HSR Layout, Bangalore, Karnataka 560102", 
    code: "DA02" 
  },
  { 
    name: "DA03 - Regional Office, Whitefield", 
    description: "ITPL Main Road, Whitefield, Bangalore, Karnataka 560066", 
    code: "DA03" 
  }
];
